/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import intl from "react-intl-universal";
import androidImage from "images/pic_android.png";
import iosImage from "images/pic_ios.png";

export default [
  {
    image: iosImage,
    name: intl.get("AppStoreDownload"),
    route:
      "https://apps.apple.com/cn/app/alclient-alist-%E6%96%87%E4%BB%B6%E7%AE%A1%E7%90%86/id6449257429?platform=iphone",
  },
  {
    image: androidImage,
    name: intl.get("AndroidDownload"),
    route:
      "https://www.geektang.cn/alist/d/guest/1.0.7.apk?sign=XCahxjgsgv0Boc5mRZAiH3Zt1LXiY9S3xN_ikkUXUf8=:0",
  },
  // {
  //   image:
  //     "https://raw.githubusercontent.com/creativetimofficial/public-assets/master/material-design-system/presentation/account/signin-basic.jpg",
  //   name: "Sign In Page",
  //   route: "/pages/authentication/sign-in",
  // },
  // {
  //   image: `${imagesPrefix}/author.jpg`,
  //   name: "Author Page",
  //   route: "/pages/landing-pages/author",
  // },
];
